module.exports = __webpack_public_path__ + "static/img/foot_code1.5e04a457.png";